'use client';
import React from 'react';
import { useEffect } from "react";
import { FormProvider } from "react-hook-form"
function MioForm({ children, methods, submitFn }) {
    // const { trigger } = methods;
    // useEffect(() => {
    //     // trigger();
    // }, [trigger])
    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(submitFn)}>
                {children}
            </form>
        </FormProvider>
    )
}
export default MioForm